module.exports = __webpack_public_path__ + "img/home-rbn-11.4b9fd56f.png";